/* =============================================================
   EP Global Scroll Animation Engine
   - Reveals sections + their children on scroll into view
   - Uses IntersectionObserver, respects prefers-reduced-motion
   - Auto-applies to every .shopify-section (opt out via
     data-ep-anim="off" on the section, or .ep-no-anim class)
   ============================================================= */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  // Signal to CSS that JS is active so we can hide-then-reveal safely.
  root.classList.add('ep-anim-ready');

  if (REDUCED) {
    // Reveal everything immediately, no motion.
    root.classList.add('ep-anim-off');
    return;
  }

  // Child selectors that get staggered inside a revealing section.
  var CHILD_SELECTOR = [
    '[data-ep-child]',
    '.ep-anim-child'
  ].join(',');

  // Heuristic child targets when a section has no explicit markers.
  // Kept intentionally shallow so we animate meaningful blocks, not every node.
  var AUTO_CHILD_SELECTOR = [
    'h1', 'h2', 'h3',
    '.ep__eyebrow', '.eyebrow',
    'p',
    '.btn', '.button', '[class*="__cta"]', '[class*="__btn"]',
    '[class*="__card"]', '[class*="__slide"]', '[class*="__item"]',
    '[class*="__media"]', '[class*="__image"]', '[class*="__img"]',
    '[class*="__col"]', '[class*="__tile"]'
  ].join(',');

  // Inside these, slides/tracks are measured by slider JS — don't offset
  // individual children or we risk breaking width calculations.
  function isInsideSlider(el) {
    return !!el.closest(
      '[class*="slider__track"],[class*="slider-track"],' +
      '[class*="__track"],[class*="swiper"],[class*="flickity"],' +
      '[class*="carousel__track"],[data-slider-track]'
    );
  }

  function markChildren(section) {
    var explicit = section.querySelectorAll(CHILD_SELECTOR);
    var list;

    if (explicit.length) {
      list = explicit;
    } else {
      // Grab a reasonable set of direct-ish content blocks.
      var found = section.querySelectorAll(AUTO_CHILD_SELECTOR);
      // Filter: skip nodes nested inside another already-picked target
      // to avoid double-staggering the same visual group.
      var picked = [];
      for (var i = 0; i < found.length; i++) {
        var el = found[i];
        if (isInsideSlider(el)) continue; // let slider JS own these
        var insideAnother = false;
        for (var j = 0; j < picked.length; j++) {
          if (picked[j].contains(el)) { insideAnother = true; break; }
        }
        if (!insideAnother) picked.push(el);
        if (picked.length >= 12) break; // cap stagger count per section
      }
      list = picked;
    }

    for (var k = 0; k < list.length; k++) {
      list[k].classList.add('ep-anim-item');
      list[k].style.setProperty('--ep-anim-i', k);
    }
  }

  // Structural chrome we never fade (breaks sticky/overlay behaviour).
  var SKIP_CLASSES = [
    'shopify-section-group-header-group',
    'shopify-section-group-footer-group'
  ];
  // Match by id fragment for known non-content sections.
  var SKIP_ID_FRAGMENTS = ['cart-drawer', 'header', 'announcement', 'footer'];

  function shouldSkip(section) {
    var inner = section.firstElementChild || section;
    if (
      section.getAttribute('data-ep-anim') === 'off' ||
      section.classList.contains('ep-no-anim') ||
      (inner && inner.getAttribute('data-ep-anim') === 'off')
    ) return true;

    for (var i = 0; i < SKIP_CLASSES.length; i++) {
      if (section.classList.contains(SKIP_CLASSES[i])) return true;
    }
    var id = (section.id || '').toLowerCase();
    for (var j = 0; j < SKIP_ID_FRAGMENTS.length; j++) {
      if (id.indexOf(SKIP_ID_FRAGMENTS[j]) !== -1) return true;
    }
    return false;
  }

  var sections = document.querySelectorAll('.shopify-section');
  var toObserve = [];

  sections.forEach(function (section) {
    if (shouldSkip(section)) {
      section.classList.add('ep-anim-skip');
      return;
    }
    section.classList.add('ep-anim-section');
    markChildren(section);
    toObserve.push(section);
  });

  if (!('IntersectionObserver' in window)) {
    // Fallback: just reveal all.
    toObserve.forEach(function (s) { s.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.12
  });

  toObserve.forEach(function (s) {
    // If a section already sits in view on load (e.g. hero), reveal
    // it on the next frame so the transition still plays.
    var rect = s.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { s.classList.add('is-visible'); });
      });
    } else {
      observer.observe(s);
    }
  });
})();
